{
  "acrobat-reader": 60095,
  "applemusic": 60096,
  "atlassian": 60097,
  "aws": 60098,
  "baidu": 60099,
  "bing": 60100,
  "bower": 60101,
  "dailymotion": 60102,
  "delicious": 60103,
  "deviantart": 60104,
  "disqus": 60105,
  "flipboard": 60106,
  "graphql": 60107,
  "hexo": 60108,
  "hipchat": 60109,
  "icq": 60110,
  "invision": 60111,
  "jekyll": 60112,
  "jira": 60113,
  "json": 60114,
  "livestream": 60115,
  "messenger": 60116,
  "meteor": 60117,
  "onenote": 60118,
  "mongodb": 60119,
  "netflix": 60120,
  "nginx": 60121,
  "odnoklassniki": 60122,
  "onedrive": 60123,
  "origin": 60124,
  "pingdom": 60125,
  "rails": 60126,
  "raspberry-pi": 60127,
  "redis": 60128,
  "redux": 60129,
  "saucelabs": 60130,
  "scorp": 60131,
  "sentry": 60132,
  "shazam": 60133,
  "shopify": 60134,
  "sinaweibo": 60135,
  "slides": 60136,
  "sublimetext": 60137,
  "swift": 60138,
  "ted": 60139,
  "telegram": 60140,
  "tesla": 60141,
  "tinder": 60142,
  "treehouse": 60143,
  "twoo": 60144,
  "udacity": 60145,
  "webstorm": 60146,
  "wix": 60147,
  "yandex-international": 60148,
  "yandex": 60149,
  "ember": 60087,
  "cpanel": 60088,
  "viber": 60089,
  "deskpro": 60090,
  "discord": 60091,
  "discourse": 60092,
  "adobe": 60059,
  "algolia": 60060,
  "atom": 60061,
  "babel": 60062,
  "coffeescript": 60063,
  "electronjs": 60064,
  "mysql": 60065,
  "oracle": 60066,
  "php": 60067,
  "sourcetree": 60068,
  "ubuntu": 60069,
  "unity": 60070,
  "unreal-engine": 60071,
  "webpack": 60072,
  "angelist": 60026,
  "app-store": 60027,
  "digg": 60030,
  "dockers": 60031,
  "envato": 60032,
  "gitlab": 60033,
  "google-drive": 60034,
  "google-play": 60035,
  "grunt": 60036,
  "gulp": 60037,
  "hacker-news": 60038,
  "imdb": 60039,
  "jenkins": 60040,
  "joomla": 60041,
  "kickstarter": 60042,
  "laravel": 60043,
  "less": 60044,
  "line": 60045,
  "npm": 60046,
  "periscope": 60047,
  "product-hunt": 60048,
  "quora": 60049,
  "skyatlas": 60050,
  "stylus": 60051,
  "travis": 60052,
  "trello": 60053,
  "uber": 60054,
  "vine": 60055,
  "visual-studio": 60056,
  "vk": 60057,
  "vuejs": 60058,
  "microsoft": 60025,
  "blogger": 60028,
  "500px": 59658,
  "amazon": 59659,
  "ampproject": 59660,
  "android": 59661,
  "angularjs": 59662,
  "apple": 59663,
  "behance": 59664,
  "bitbucket": 59665,
  "bluetooth-b": 59666,
  "cloudflare": 59667,
  "codepen": 59668,
  "css3": 59669,
  "dribbble": 59670,
  "dropbox": 59671,
  "facebook": 59672,
  "flickr": 59673,
  "foursquare": 59674,
  "git": 59675,
  "github": 59676,
  "google-plus": 59677,
  "google": 59678,
  "hangout": 59679,
  "houzz": 59680,
  "html5": 59681,
  "instagram": 59682,
  "java": 59683,
  "jquery": 59684,
  "jsfiddle": 59685,
  "linkedin": 59686,
  "linux": 59687,
  "magento": 59688,
  "maxcdn": 59689,
  "medium": 59690,
  "meetup": 59691,
  "nodejs": 59692,
  "opencart": 59693,
  "pinterest": 59694,
  "playstation": 59695,
  "python": 59696,
  "react": 59697,
  "reddit": 59698,
  "ruby": 59699,
  "sass": 59700,
  "skype": 59701,
  "slack": 59702,
  "snapchat": 59703,
  "soundcloud": 59704,
  "spotify": 59705,
  "stack-overflow": 59706,
  "steam": 59707,
  "stumbleupon": 59708,
  "svn": 59709,
  "swarm": 59710,
  "tripadvisor": 59711,
  "tumblr": 59712,
  "twitch": 59713,
  "twitter": 59714,
  "vimeo": 59715,
  "wetransfer": 59716,
  "whatsapp": 59717,
  "wifi-logo": 59718,
  "wikipedia": 59719,
  "windows": 59720,
  "wordpress": 59721,
  "xbox": 59722,
  "yahoo": 59723,
  "yelp": 59724,
  "youtube-play": 59725,
  "cocoapods": 60200,
  "composer": 60201,
  "yarn": 60202,
  "language": 59943,
  "toggle-off": 59948,
  "toggle-on": 60029,
  "anchor": 60094,
  "archive": 60150,
  "at": 60151,
  "ban": 60152,
  "battery-half": 60153,
  "battery-full": 60154,
  "battery-empty": 60155,
  "battery-quarter": 60156,
  "battery-three-quarters": 60157,
  "bell-alt": 60158,
  "bell": 60159,
  "bookmark-alt": 60160,
  "bookmark": 60161,
  "bug": 60162,
  "calculator": 60163,
  "calendar": 60164,
  "crosshairs": 60165,
  "desktop": 60166,
  "download": 60167,
  "film": 60168,
  "history": 60169,
  "hourglass-end": 60170,
  "hourglass-half": 60171,
  "hourglass-start": 60172,
  "hourglass": 60173,
  "info": 60174,
  "key": 60175,
  "keyboard": 60176,
  "laptop": 60177,
  "lightbulb": 60178,
  "magnet": 60179,
  "map-marker-alt": 60180,
  "map-marker": 60181,
  "map": 60182,
  "mobile-alt": 60183,
  "mobile": 60184,
  "paw": 60185,
  "phone": 60186,
  "power": 60187,
  "qrcode": 60188,
  "question": 60189,
  "search": 60190,
  "sitemap": 60191,
  "star-half": 60192,
  "stopwatch": 60193,
  "tablet-alt": 60194,
  "tablet": 60195,
  "ticket": 60196,
  "tv": 60197,
  "upload": 60198,
  "user-secret": 60199,
  "camera": 59798,
  "clock": 59799,
  "close-a": 59800,
  "code": 59801,
  "comment": 59802,
  "commenting": 59803,
  "comments": 59804,
  "crop": 59805,
  "cursor": 59806,
  "database": 59807,
  "date": 59808,
  "earth": 59809,
  "email": 59810,
  "eye": 59811,
  "female": 59812,
  "favorite": 59813,
  "filter": 59814,
  "fire": 59815,
  "flag": 59816,
  "flash": 59817,
  "home": 59818,
  "link": 59819,
  "locked": 59820,
  "male": 59821,
  "minus-a": 59822,
  "more-v-a": 59823,
  "more-v": 59824,
  "move-h-a": 59825,
  "move-h": 59826,
  "nav-icon-a": 59827,
  "nav-icon-grid-a": 59828,
  "nav-icon-grid": 59829,
  "nav-icon-list-a": 59830,
  "nav-icon-list": 59831,
  "nav-icon": 59832,
  "navigate": 59833,
  "paper-plane": 59834,
  "person": 59835,
  "persons": 59836,
  "picture": 59837,
  "plus-a": 59838,
  "print": 59839,
  "quote-a-left": 59840,
  "quote-a-right": 59841,
  "quote-left": 59842,
  "quote-right": 59843,
  "reply": 59844,
  "rss": 59845,
  "scissors": 59846,
  "share-a": 59847,
  "share": 59848,
  "trash": 59849,
  "unlocked": 59850,
  "usb": 59851,
  "wifi": 59852,
  "world-o": 59853,
  "world": 59854,
  "zoom": 59855,
  "adjust": 60015,
  "recycle": 60016,
  "pinboard": 60093,
  "zoom-minus": 60082,
  "zoom-plus": 60083,
  "check": 60084,
  "asterisk": 60085,
  "hashtag": 60086,
  "checkbox-active": 59778,
  "checkbox-passive": 59779,
  "radio-btn-active": 59780,
  "radio-btn-passive": 59781,
  "shopping-bag-1": 60011,
  "shopping-bag": 60012,
  "shopping-barcode": 60017,
  "shopping-basket-add": 60018,
  "shopping-basket-remove": 60019,
  "shopping-basket": 60020,
  "shopping-package": 60021,
  "shopping-pos-machine": 60022,
  "shopping-sale": 60023,
  "shopping-store": 60024,
  "angle-dobule-down": 59748,
  "angle-dobule-left": 59749,
  "angle-dobule-right": 59750,
  "angle-dobule-up": 59751,
  "angle-down": 59752,
  "angle-left": 59753,
  "angle-right": 59754,
  "angle-up": 59755,
  "arrow-down-l": 59756,
  "arrow-down": 59757,
  "arrow-expand": 59758,
  "arrow-h": 59759,
  "arrow-left-l": 59760,
  "arrow-left": 59761,
  "arrow-move": 59762,
  "arrow-resize": 59763,
  "arrow-return-left": 59764,
  "arrow-return-right": 59765,
  "arrow-right-l": 59766,
  "arrow-right": 59767,
  "arrow-swap": 59768,
  "arrow-up-l": 59769,
  "arrow-up": 59770,
  "arrow-v": 59771,
  "caret-down": 59772,
  "caret-left": 59773,
  "caret-right": 59774,
  "caret-up": 59775,
  "fi": 59776,
  "fontisto": 59777,
  "backward": 59866,
  "eject": 59867,
  "equalizer": 59868,
  "forward": 59869,
  "headphone": 59870,
  "heart": 59871,
  "mic": 59872,
  "music-note": 59873,
  "pause": 59874,
  "play-list": 59875,
  "play": 59876,
  "player-settings": 59877,
  "podcast": 59878,
  "random": 59879,
  "record": 59880,
  "star": 59881,
  "step-backwrad": 59882,
  "step-forward": 59883,
  "stop": 59884,
  "volume-down": 59885,
  "volume-mute": 59886,
  "volume-off": 59887,
  "volume-up": 59888,
  "airplay": 60008,
  "bold": 59918,
  "broken-link": 59919,
  "center-align": 59920,
  "close": 59921,
  "columns": 59922,
  "copy": 59923,
  "eraser": 59924,
  "export": 59925,
  "file-1": 59926,
  "file-2": 59927,
  "folder": 59928,
  "font": 59929,
  "import": 59930,
  "indent": 59931,
  "italic": 59932,
  "justify": 59933,
  "left-align": 59934,
  "link2": 59935,
  "list-1": 59936,
  "list-2": 59937,
  "outdent": 59938,
  "paperclip": 59939,
  "paragraph": 59940,
  "paste": 59941,
  "preview": 59942,
  "print2": 59943,
  "redo": 59944,
  "right-align": 59945,
  "save-1": 59946,
  "save": 59947,
  "scissors2": 59948,
  "strikethrough": 59949,
  "subscript": 59950,
  "superscript": 59951,
  "table-1": 59952,
  "table-2": 59953,
  "text-height": 59954,
  "text-width": 59955,
  "underline": 59956,
  "undo": 59957,
  "cloud-down": 59958,
  "cloud-refresh": 59959,
  "cloud-up": 59960,
  "cloudy-gusts": 59961,
  "cloudy": 59962,
  "compass": 59963,
  "day-cloudy": 59964,
  "day-haze": 59965,
  "day-lightning": 59966,
  "day-rain": 59967,
  "day-snow": 59968,
  "day-sunny": 59969,
  "fog": 59970,
  "horizon-alt": 59971,
  "horizon": 59972,
  "lightning": 59973,
  "lightnings": 59974,
  "night-alt-cloudy": 59975,
  "night-alt-lightning": 59976,
  "night-alt-rain": 59977,
  "night-alt-snow": 59978,
  "night-clear": 59979,
  "rain": 59980,
  "rainbow": 59981,
  "rains": 59982,
  "snow": 59983,
  "snows": 59984,
  "thermometer": 59985,
  "umbrella": 59986,
  "wind": 59987,
  "confused": 59988,
  "dizzy": 59989,
  "expressionless": 59990,
  "frowning": 59991,
  "heart-eyes": 59992,
  "laughing": 59993,
  "mad": 59994,
  "nervous": 59995,
  "neutral": 59996,
  "open-mouth": 59997,
  "rage": 59998,
  "slightly-smile": 59999,
  "smiley": 60000,
  "smiling": 60001,
  "stuck-out-tongue": 60002,
  "sunglasses": 60003,
  "surprised": 60004,
  "tongue": 60005,
  "wink": 60006,
  "zipper-mouth": 60007,
  "aids": 60233,
  "ambulance": 60234,
  "bandage": 60235,
  "bed-patient": 60236,
  "blood-drop": 60237,
  "blood-test": 60238,
  "blood": 60239,
  "dna": 60240,
  "doctor": 60241,
  "drug-pack": 60242,
  "first-aid-alt": 60243,
  "heart-alt": 60244,
  "heartbeat-alt": 60245,
  "heartbeat": 60246,
  "helicopter-ambulance": 60247,
  "hospital": 60248,
  "injection-syringe": 60249,
  "laboratory": 60250,
  "nurse": 60251,
  "nursing-home": 60252,
  "paralysis-disability": 60253,
  "pills": 60254,
  "prescription": 60255,
  "pulse": 60256,
  "stethoscope": 60257,
  "surgical-knife": 60258,
  "tablets": 60259,
  "test-bottle": 60260,
  "test-tube-alt": 60261,
  "test-tube": 60262,
  "thermometer-alt": 60263,
  "american-express": 59856,
  "credit-card": 59857,
  "google-wallet": 59858,
  "iyzigo": 59859,
  "mastercard": 59860,
  "paypal-p": 59861,
  "paypal": 59862,
  "payu": 59863,
  "troy": 59864,
  "visa": 59865,
  "dinners-club": 60010,
  "apple-pay": 60009,
  "discover": 60013,
  "jcb": 60014,
  "dislike": 59796,
  "like": 59797,
  "audio-description": 59648,
  "blind": 59649,
  "braille": 59650,
  "deaf": 59651,
  "fa-american-sign-language-interpreting": 59652,
  "low-vision": 59654,
  "tty": 59655,
  "universal-acces": 59656,
  "wheelchair": 59657,
  "area-chart": 59732,
  "bar-chart": 59733,
  "line-chart": 59734,
  "pie-chart-1": 59735,
  "pie-chart-2": 59736,
  "chrome": 59726,
  "edge": 59727,
  "firefox": 59728,
  "internet-explorer": 59729,
  "opera": 59730,
  "safari": 59731,
  "bitcoin": 59737,
  "dollar": 59738,
  "euro": 59739,
  "gbp": 59740,
  "gg": 59741,
  "ils": 59742,
  "inr": 59743,
  "krw": 59744,
  "rouble": 59745,
  "tl": 59746,
  "yen": 59747,
  "genderless": 59782,
  "intersex": 59783,
  "mars-double": 59784,
  "mars-stroke-h": 59785,
  "mars-stroke-v": 59786,
  "mars-stroke": 59787,
  "mars": 59788,
  "mercury": 59789,
  "neuter": 59790,
  "transgender-alt": 59791,
  "transgender": 59792,
  "venus-double": 59793,
  "venus-mars": 59794,
  "venus": 59795,
  "automobile": 59899,
  "bicycle": 59900,
  "bus": 59901,
  "car": 59902,
  "helicopter": 59903,
  "metro": 59904,
  "motorcycle": 59905,
  "plane": 59906,
  "rocket": 59907,
  "ship": 59908,
  "subway": 59909,
  "taxi": 59910,
  "train": 59911,
  "truck": 59912,
  "yacht": 59913,
  "beach-slipper": 60203,
  "bus-ticket": 60204,
  "cocktail": 60205,
  "compass-alt": 60206,
  "direction-sign": 60207,
  "do-not-disturb": 60208,
  "flotation-ring": 60209,
  "holiday-village": 60210,
  "hot-air-balloon": 60211,
  "hotel-alt": 60212,
  "hotel": 60213,
  "island": 60214,
  "money-symbol": 60215,
  "parasol": 60216,
  "passport-alt": 60217,
  "passport": 60218,
  "photograph": 60219,
  "plane-ticket": 60220,
  "room": 60221,
  "sait-boat": 60222,
  "snorkel": 60223,
  "suitcase-alt": 60224,
  "suitcase": 60225,
  "sun": 60226,
  "sunglasses-alt": 60227,
  "swimsuit": 60228,
  "tent": 60229,
  "ticket-alt": 60230,
  "train-ticket": 60231,
  "wallet": 60232,
  "circle-o-notch": 59889,
  "propeller-1": 59890,
  "propeller-2": 59891,
  "propeller-3": 59892,
  "propeller-4": 59893,
  "spinner-cog": 59894,
  "spinner-fidget": 59895,
  "spinner-refresh": 59896,
  "spinner-rotate-forward": 59897,
  "spinner": 59898,
  "snowflake": 60081,
  "snowflake-1": 60073,
  "snowflake-2": 60074,
  "snowflake-3": 60075,
  "snowflake-4": 60076,
  "snowflake-5": 60077,
  "snowflake-6": 60078,
  "snowflake-7": 60079,
  "snowflake-8": 60080,
  "curve": 59915,
  "ellipse": 59916,
  "rectangle": 59917,
  "shield": 59914
}